import React, { Component } from 'react';
import { connect } from "react-redux";
import $ from 'jquery';
import {FormattedMessage, injectIntl} from "react-intl";
import trim from "lodash/trim";
import lastIndexOf from "lodash/lastIndexOf";

import {showCheckoutPopup, changeMessageBoxState, showDocuSign} from "../../actions/actionFunctions";
import { submitPayment } from '../../api/server-api';
import {supportedCountriesList} from '../../reducers/cartReducer';
import {getTotalPrice, getQuotePriceWithTaxes, toFixedPrice, getPriceWithCurrency} from '../../misc/helpers';
import Config from "../../config";
import {showOrderCompletePopup} from "../../actions/shoppingCartFunctions";
import {showQuoteSavedNotification} from "../ui/successNotification";
import {loaderDisable, loaderEnable} from "../ui/loaderView";
import {renderErrorPopup} from "../../api/api-popups";
import {getDepositAmount} from "../priceWorksheet/discountFunctions";

const defaultCountryValue = "Select Country";

class CheckoutPopup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      paymentInfo: {
        name: '',
        ccNum: '',
        expYear: '',
        expMonth: '',
        cvv: '',
        zipCode: '',
        country: defaultCountryValue,
      }
    }
  }

  scrollIntoView = (e) => {
    let target = e.target;
    window.setTimeout(() => {
      $('.cart-checkout-popup-body').scrollTop(target.offsetTop - 85);
    }, 100);
    if(window.innerHeight <= 350) {
      //$('.cart-checkout-popup').css({'top': '-25px', 'height': 'calc(100vh + 25px)'});
      Object.assign(document.querySelector('.cart-checkout-popup').style, {top: '-75px', height: 'calc(100vh + 75px)'});
      Object.assign(document.querySelector('.cart-checkout-popup-body').style, {maxHeight: "calc(100vh)", paddingBottom: '300px'});
    }
  };

  scrollBack = () => {
    document.querySelector('.cart-checkout-popup').removeAttribute('style');
    document.querySelector('.cart-checkout-popup-body').removeAttribute('style');
  };

  componentDidUpdate() {
    if(window.checkoutSuccess) {
      this.props.showCheckoutPopup(false);
    }
  }

  updatePaymentInfo = (propName, value) => {
    let paymentInfo = {...this.state.paymentInfo};
    paymentInfo[propName] = value;
    this.setState({paymentInfo});
    return paymentInfo;
  };

  setPaymentInfo = (e, propName) => this.updatePaymentInfo(propName, e.target.value);

  submitPayment = () => {
    let errors = [];
    if(!trim(this.state.paymentInfo.name)) {
      errors.push("checkoutPopup.errors.missingName");
    }
    if(!this.state.paymentInfo.country || trim(this.state.paymentInfo.country) == "Select Country") {
      errors.push("checkoutPopup.errors.missingCountry");
    }
    if(!trim(this.state.paymentInfo.zipCode)) {
      errors.push("checkoutPopup.errors.missingPostal");
    }
    if(!trim(this.state.paymentInfo.ccNum)) {
      errors.push("checkoutPopup.errors.missingCcNumber");
    }
    if(!trim(this.state.paymentInfo.cvv)) {
      errors.push("checkoutPopup.errors.missingCVV");
    }
    if(!trim(this.state.paymentInfo.expMonth)) {
      errors.push("checkoutPopup.errors.missingExpMonth");
    }
    if(!trim(this.state.paymentInfo.expYear)) {
      errors.push("checkoutPopup.errors.missingExpYear");
    }
    if(Config.isMobile() && errors.length > 0) {
      errors = ["checkoutPopup.errors.allFieldsRequired"];
    }
    if(errors.length > 0) {
      this.props.changeMessageBoxState({
        visible: true,
        error: true,
        message: errors,
        inline: !Config.isMobile(),
        buttons: [{
          text: "checkoutPopup.errors.okButton",
          color: "red",
          click: () => {
            this.props.changeMessageBoxState({visible: false});
          }
        }]
      });
    } else {
      loaderEnable();
      const paymentAmount = this.updatePaymentInfo('amount', this.getPaymentAmount());
      return submitPayment(paymentAmount)
        .then((res) => {
          loaderDisable();
          if(res.transactionResponse.responseCode === '1') {
            showQuoteSavedNotification();
            this.props.showCheckoutPopup(false);
            window.checkoutSuccess = true;
            if (this.props.receiptUrl && !(this.props.fabricatorData.settings.useContractSigning && document.kvConfig.isBackend)) {
              // show receipt only if contract is off, if it is on - we show receipt after contract is signed
              window.open(this.props.receiptUrl, "_blank");
            }
            if (this.props.checkoutCallback) { // this should be always a function, but let's check
              this.props.checkoutCallback();
              this.props.showDocuSign(false, null); // erase callback after executing
            } else {
              this.props.showOrderCompletePopup(true);
            }
          } else {
            let msg = '';
            let error = true;
            if(res && (res.transactionResponse && res.transactionResponse.errors && res.transactionResponse.errors.length > 0) || res.error) {
              msg = res.transactionResponse.errors[0].errorText || res.error;
            }
            else if (res && res.message && res.message.messageDetails.length > 0) {
              msg = res.message.messageDetails[0].text;
            }

            let sepIdx = lastIndexOf(msg, '-');
            if(sepIdx >= 0) {
              msg = trim(msg.substr(sepIdx + 1));
            }

            this.props.changeMessageBoxState({
              visible: true,
              message: msg,
              error,
              buttons: [{
                text: "checkoutPopup.errors.okButton",
                color: "red",
                click: () => {
                  this.props.changeMessageBoxState({visible: false});
                }
              }]
            });
          }
        })
        .catch(error => {
          const offlineRetryCallback = submitPayment.bind(this, paymentAmount)
          renderErrorPopup(error, "", offlineRetryCallback);
          loaderDisable();
        })
    }
  };

  getPaymentAmount = () => {
    const {discountSections, fabricatorData} = this.props;
    const totalPrice = getTotalPrice();
    const grandTotal = getQuotePriceWithTaxes(totalPrice);
    return getDepositAmount(discountSections, grandTotal, fabricatorData) || grandTotal
  }

  render() {
    if (!this.props.checkoutPopupVisible) {
      return null;
    }

    const {intl} = this.props;
    const fabricatorSettings = this.props.fabricatorData.settings;

    const depositTotal = this.getPaymentAmount();

    const dropDownStyles = this.state.toggle ? { height:window.innerHeight - 60 } : {};
    if (this.state.toggle) {
      dropDownStyles.height = (this.props.windowWidth > 991 && window.innerHeight > 320) ? 320 : window.innerHeight - 60
    }
    return (
      <div className='overlay cart-checkout-container'>
        <div className='cart-checkout-popup cart-checkout-popup--payment'
             onClick={(e) => {e.preventDefault(); e.stopPropagation();}}>
          <div className='cart-checkout-popup-header'>
            {/*<div className='cart-checkout-popup-header-icon'/>*/}
            <div className='cart-checkout-popup-header-text'>
              <FormattedMessage id="checkoutPopup.title"/>
            </div>
            <div className='ui-close cart-checkout-popup-header-close' onClick={() => this.props.showCheckoutPopup(false)}/>
            <div className='cart-checkout-popup-header-total'>
              <div className='cart-checkout-popup-header-total-title'><FormattedMessage id="checkoutPopup.total"/></div>
              <div className='cart-checkout-popup-header-total-amount'>
                {getPriceWithCurrency(fabricatorSettings, toFixedPrice(depositTotal))}
              </div>
            </div>
          </div>
          <div className='cart-checkout-popup-body'>
            <div className="payment">
              {/*<div className="payment-invoice">
                            <button
                            className="ui-button5 ui-button5--blue ui-button5--bold ui-button5--small ui-button5--round ui-button5--with-icon">
                            <span className="ui-button5-icon ui-button5-icon--list"/>
                            VIEW ORDER INVOICE
                            </button>
        </div>*/}
              <ul className="payment-methods">
                <div className="method-info">
                  <div className="method-info__logo method-info__logo--card"/>
                  <p className="method-info__text"><FormattedMessage id="checkoutPopup.paymentMethodsText"/></p>
                </div>
                <div className="method-inputs">
                  <div className="method-input">
                    <input className="ui-input" id="cc_num"
                           placeholder={intl.formatMessage({id: "checkoutPopup.inputs.ccNum"})}
                           value={this.state.paymentInfo.ccNum}
                           onChange={(e) => this.updatePaymentInfo('ccNum', e.target.value)}
                           onFocus={this.scrollIntoView} onBlur={this.scrollBack} />
                  </div>
                  <div className="method-input method-input--date-and-cvv">
                    <div className="method-input__date">
                      <input className="ui-input" id="exp_month"
                             size="2"
                             placeholder={intl.formatMessage({id: "checkoutPopup.inputs.expMonth"})}
                             maxLength="2"
                             value={this.state.paymentInfo.expMonth}
                             onChange={(e) => this.updatePaymentInfo('expMonth', e.target.value)}
                             onFocus={this.scrollIntoView} onBlur={this.scrollBack} />
                      <input className="ui-input" id="exp_year" size="4"
                             placeholder={intl.formatMessage({id: "checkoutPopup.inputs.expYear"})}
                             maxLength="4"
                             value={this.state.paymentInfo.expYear}
                             onChange={(e) => this.updatePaymentInfo('expYear', e.target.value)}
                             onFocus={this.scrollIntoView} onBlur={this.scrollBack} />
                      <p className="method-input__description">
                        <FormattedMessage id="checkoutPopup.inputs.expDateMessage"/>
                      </p>
                    </div>
                    <div className="method-input__cvv">
                      <input className="ui-input" id="cvv" size="4"
                             placeholder={intl.formatMessage({id: "checkoutPopup.inputs.cvv"})}
                             maxLength="4"
                             value={this.state.paymentInfo.cvv}
                             onChange={(e) => this.updatePaymentInfo('cvv', e.target.value)}
                             onFocus={this.scrollIntoView} onBlur={this.scrollBack} />
                      <p className="method-input__description">
                        <FormattedMessage id="checkoutPopup.inputs.cvvMessage"/>
                      </p>
                    </div>
                  </div>
                </div>
              </ul>
              <ul className="payment-user">
                <li className="payment-user__input">
                  <input type="text"
                         placeholder={intl.formatMessage({id: "checkoutPopup.inputs.nameOnCard"})}
                         id="name" className="ui-input"
                         value={this.state.paymentInfo.name}
                         onChange={(e) => this.updatePaymentInfo('name', e.target.value)}
                         onFocus={this.scrollIntoView} onBlur={this.scrollBack} />
                </li>
                <li className="payment-user__input payment-user__input--half payment-user__input--left">
                  <select name="country"
                          id="country"
                          className={"ui-input ui-input--select" + (this.state.paymentInfo.country === defaultCountryValue ? " ui-input--select--default" : "")}
                          value={this.state.paymentInfo.country}
                          onChange={(event) => {
                            this.updatePaymentInfo('country', event.target.value)
                          }}>
                    {[defaultCountryValue, ...supportedCountriesList].map((country, countryIndex) => {
                      return <option key={countryIndex} value={country}>{country}</option>
                    })}
                  </select>
                </li>
                <li className="payment-user__input payment-user__input--half payment-user__input--right">
                  <input type="text"
                         placeholder={intl.formatMessage({id: "checkoutPopup.inputs.postalCode"})}
                         id="zip" className="ui-input"
                         value={this.state.paymentInfo.zipCode}
                         onChange={(e) => this.updatePaymentInfo('zipCode', e.target.value)}
                         onFocus={this.scrollIntoView} onBlur={this.scrollBack} />
                </li>
              </ul>
            </div>
          </div>
          <div className='cart-checkout-popup-footer'>
            <button className="ui-button2 ui-button2--green" onClick={this.submitPayment}>
              <span className="ui-button-continue">
                <FormattedMessage id="checkoutPopup.submitButton"/>
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const {discountSections} = store.priceWorksheetState;
  return {
    checkoutPopupVisible: store.cartState.checkoutPopupVisible,
    deposit: store.fabricatorState.settings.deposit,
    depositVisible: store.cartState.depositVisible,
    fabricatorData: store.fabricatorState,
    receiptUrl: store.printState.receiptUrl,
    checkoutCallback: store.docuSignState.callback,
    discountSections,
  };
};
const mapDispatchToProps = {
  showCheckoutPopup,
  changeMessageBoxState,
  showOrderCompletePopup,
  showDocuSign,
};
export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(CheckoutPopup)
)
